/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WellPadTreeView } from './WellPadTreeView';
import {
    WellPadTreeViewFromJSON,
    WellPadTreeViewFromJSONTyped,
    WellPadTreeViewToJSON,
} from './WellPadTreeView';

/**
 * 
 * @export
 * @interface MonitoringWellFieldTreeView
 */
export interface MonitoringWellFieldTreeView {
    /**
     * 
     * @type {number}
     * @memberof MonitoringWellFieldTreeView
     */
    fieldId?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitoringWellFieldTreeView
     */
    fieldTitle: string;
    /**
     * 
     * @type {Array<WellPadTreeView>}
     * @memberof MonitoringWellFieldTreeView
     */
    pads?: Array<WellPadTreeView>;
}

/**
 * Check if a given object implements the MonitoringWellFieldTreeView interface.
 */
export function instanceOfMonitoringWellFieldTreeView(value: object): value is MonitoringWellFieldTreeView {
    if (!('fieldTitle' in value) || value['fieldTitle'] === undefined) return false;
    return true;
}

export function MonitoringWellFieldTreeViewFromJSON(json: any): MonitoringWellFieldTreeView {
    return MonitoringWellFieldTreeViewFromJSONTyped(json, false);
}

export function MonitoringWellFieldTreeViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoringWellFieldTreeView {
    if (json == null) {
        return json;
    }
    return {
        
        'fieldId': json['fieldId'] == null ? undefined : json['fieldId'],
        'fieldTitle': json['fieldTitle'],
        'pads': json['pads'] == null ? undefined : ((json['pads'] as Array<any>).map(WellPadTreeViewFromJSON)),
    };
}

export function MonitoringWellFieldTreeViewToJSON(value?: MonitoringWellFieldTreeView | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fieldId': value['fieldId'],
        'fieldTitle': value['fieldTitle'],
        'pads': value['pads'] == null ? undefined : ((value['pads'] as Array<any>).map(WellPadTreeViewToJSON)),
    };
}

